import script from "./TableSelectWagons.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableSelectWagons.vue?vue&type=script&setup=true&lang=ts"

import "./TableSelectWagons.vue?vue&type=style&index=0&id=f57458ee&lang=scss"

const __exports__ = script;

export default __exports__